import { createFileRoute } from "@tanstack/react-router";

import { CHARACTER_COUNTER_FAQS } from "@/components/marketing/character-counter-faqs";
import { CharacterCounterTool } from "@/components/marketing/character-counter-tool";
import { toolPageHead } from "@/lib/seo";

/** FAQs come from their own module; see `tools.thread-splitter`. */
export const Route = createFileRoute("/(public)/tools/character-counter")({
  head: () => toolPageHead("characterCounter", CHARACTER_COUNTER_FAQS),
  component: CharacterCounterTool,
});
